import { useSearchParams } from 'react-router-dom'
import { l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { useReplaceParam } from 'common/actions/integrations/TikTokAds/hooks/useReplaceParam'
import { alert } from 'common/core'
import { openInstagramChangeConnectionModal } from 'common/core/actions/uiActions'
import { useDidMountEffect } from 'utils/commonHooks'

import { CHANGE_CONNECTION_ERROR_PARAM } from './constants'

export const useInstagramChangeConnectionError = () => {
  const dispatch = useAppDispatch()
  const replaceHistoryWithoutParam = useReplaceParam()
  const [query] = useSearchParams()
  const hasChangeConnectionError = Boolean(query.get(CHANGE_CONNECTION_ERROR_PARAM))

  useDidMountEffect(() => {
    if (hasChangeConnectionError) {
      dispatch(openInstagramChangeConnectionModal())

      alert(l.translate('Your Instagram wouldn’t reconnect! Please try again later.'), 'danger')

      replaceHistoryWithoutParam(CHANGE_CONNECTION_ERROR_PARAM)
    }
  })
}
